import { ListItem, ListItemProps, styled } from '@material-ui/core';

const DefaultListItem = ({ button, ...props }: ListItemProps) => (
  <ListItem
    ContainerComponent="div"
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- MUI v4 typings: https://github.com/mui/material-ui/issues/14971
    button={button as any}
    {...props}
  />
);

export const SelectListItem = styled(DefaultListItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'nowrap',
  justifyContent: 'space-between',
  paddingRight: 0,
  gap: theme.spacing(1),
}));
